import React, { useState } from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

interface ActionCardCatagoriesProps {
  icon: React.ReactNode;
  title: string;
  message: string;
  border: string;
  background: string;
  variant?: 'default' | 'custom';
  onClick?: () => void;
}

export const ActionCardCatagories: React.FC<ActionCardCatagoriesProps> = ({ 
  icon, 
  title,
  message, 
  background,
  border,
  variant = 'default',
  onClick 
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: '220px',
        height: '250px',
        position: 'relative',
        background: 'white',
        borderRadius: '14px',
        overflow: 'hidden',
        fontFamily: 'Roboto, sans-serif',
        boxShadow: isHovered ? '0 4px 12px rgba(0, 0, 0, 0.2)' : '0 2px 6px rgba(0, 0, 0, 0.1)',
        transition: 'box-shadow 0.3s ease',
        cursor: 'pointer',
      }}
    >
      {/* Colored top section */}
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: '0px',
          top: '0px',
          background: background,
          borderTopLeftRadius: '14px',
          borderTopRightRadius: '14px',
        }}
      >
        {/* Star/Asterisk overlay with animation */}
        {variant === 'default' && (
          <svg
            style={{
              position: 'absolute',
              width: '123px',
              height: '129px',
              left: '50%',
              top: '40%',
              transform: `translate(-50%, -50%) ${
                isHovered ? 'rotate(30deg) scale(1.1)' : 'rotate(0deg) scale(1)'
              }`,
              mixBlendMode: 'overlay',
              opacity: 0.5,
              transition: 'transform 1s cubic-bezier(0.25, 1, 0.5, 1)',
              willChange: 'transform',
            }}
            viewBox="155 23 130 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M192.581 112.418L164.848 119.822L155.347 84.4228L183.073 76.9912L162.771 56.6692L188.669 30.7707L208.991 51.0729L216.423 23.347L251.822 32.848L244.418 60.5816L272.152 53.1777L281.653 88.5772L253.927 96.0087L274.229 116.331L248.331 142.229L228.009 121.927L220.577 149.653L185.178 140.152L192.581 112.418Z"
              fill="#D9D9D9"
            />
          </svg>
        )}
        <div
          style={{
            width: '100px',
            height: '100px',
            position: 'absolute',
            top: '44%',
            left: '49%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {icon}
        </div>
      </div>

      {/* Title section */}
      <div
        style={{
          position: 'relative',
          top: '146px',
          right:'22px',
          width: '214px',
          height: '76px',
          background: 'white',
          borderBottomLeftRadius: '14px',
          borderBottomRightRadius: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px',
          boxSizing: 'border-box',
        }}
      >
        <h3
          style={{
            margin: 0,
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px',
            color: 'rgba(0, 0, 0, 0.88)',
            textAlign: 'center',
            whiteSpace: 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {title}
        </h3>
      </div>
    </Card>
  );
};

export default ActionCardCatagories;